import PropTypes from "prop-types";
import React, { Component } from "react";
import ContextMenu from "../Context/ContextMenu";
export default class DropdownMenu extends Component {
  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(ContextMenu, rest, children);
  }

}